import { baseUrl } from 'components/dashboard/key/cards/NetworkCard'

export const buildOptionsList = (type, data) =>
  type === 'network'
    ? data.map(([id, networkData]) => {
        let imgSrc
        try {
          const url = new URL(networkData.iconUrl)
          imgSrc = `${baseUrl}${url.pathname}`
        } catch (e) {
          imgSrc = `/images/icons/network-icons/${id}.svg`
        }
        return {
          customIcon: imgSrc,
          text: networkData.alias,
          value: id
        }
      })
    : data.map(key => ({
        description: key.id,
        text: key.name,
        value: key.id
      }))
